import React, { useState } from "react";
import { getAuth, updatePassword } from "firebase/auth"; // Import getAuth
import Box from "@mui/material/Box";
import { TextField, Container, Stack, Button, Typography } from "@mui/material";
import { useSnackbar } from "notistack";

function Settings() {
  const auth = getAuth(); // Initialize getAuth
  const user = auth.currentUser;
  const [passwords, setPasswords] = useState({
    curr_password: null,
    password: null,
    confirm_password: null
  });

  const { enqueueSnackbar } = useSnackbar();

  const handleUpdatePassword = () => {
    if (passwords.password !== passwords.confirm_password) {
      enqueueSnackbar("Passwords do not match!", { variant: "error" });
      return;
    }

    updatePassword(user, passwords.password) // Use passwords.password for the new password
      .then(() => {
        enqueueSnackbar("Password changed successfully!", { variant: "success" });
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
      });
  };

  return (
    <Container>
      <Stack spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Settings
          </Typography>
        </Stack>

        <Typography variant="h6">
          Update Password
        </Typography>

        <TextField
          required
          fullWidth
          value={passwords.curr_password || ""}
          id="curr-password"
          label="Password"
          name="curr_password"
          size="medium"
          type="password"
          onChange={(e) => {
            setPasswords({ ...passwords, curr_password: e.target.value });
          }}
        />

        <TextField
          required
          fullWidth
          value={passwords.password || ""}
          id="password"
          label="New Password"
          name="password"
          size="medium"
          type="password"
          onChange={(e) => {
            setPasswords({ ...passwords, password: e.target.value });
          }}
        />

        <TextField
          required
          fullWidth
          value={passwords.confirm_password || ""}
          id="confirm_password"
          label="Confirm New Password"
          name="confirm_password"
          size="medium"
          type="password"
          onChange={(e) => {
            setPasswords({ ...passwords, confirm_password: e.target.value });
          }}
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleUpdatePassword} // Trigger handleUpdatePassword
          >
            Save
          </Button>
        </Box>
      </Stack>
    </Container>
  );
}

export default Settings;
